import { UUID } from '@umanforge/common';
import { UserIcon } from 'components/icons/user_icon.component';
import { UserShieldIcon } from 'components/icons/user_shield_icon.component';

import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import Switch from 'react-switch';
import { useState } from 'react';


interface SwitchAdminUserProps {
  objectId: UUID;
  isDisabled?: boolean;
  defaultValue?: boolean;
  onChange: ( isAdmin: boolean ) => void;
}

export function SwitchAdminUser( { objectId, isDisabled, defaultValue, onChange }: SwitchAdminUserProps ) {
  const { t } = useTranslation();

  const [ isAdmin ] = useState<boolean>( defaultValue ?? false );

  return (
    <>
      <span
        className='flex gap-1 pl-1'
        id={ 'isAdmin-' + objectId}
      >
        <Switch
          disabled={ isDisabled }
          checked={ isAdmin }
          onChange={ isChecked => {
            onChange( isChecked );
          } }
          uncheckedIcon={
            <div className='flex rounded-r-full w-full h-full items-center justify-center'>
              <UserIcon className='h-[14px] select-none cursor-pointer fill-white'/>
            </div>
          }
          checkedIcon={
            <div className='flex rounded-l-full w-full h-full items-center justify-center'>
              <UserShieldIcon className='h-[14px] pl-1 select-none cursor-pointer fill-white'/>
            </div>
          }
        />
      </span>
      <Tooltip
        anchorSelect={ '#isAdmin-' + objectId }
        className='z-[1000] max-w-[600px] text-wrap'
        place="top"
        positionStrategy="fixed"
      >
        <span>
          {
            isAdmin ?
              t( 'The user is Admin' )
              :
              t( 'Simple user' )
          }
        </span>
      </Tooltip>
    </>
  );
}